var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"text-body",attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.5 11.625L9 7.249 10.562 6l4.5 5.625-4.5 5.624L9 16l3.5-4.375z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }